// extracted by mini-css-extract-plugin
export default {"input":"Input_input__xC1Gr","input__icon":"Input_input__icon__whta8","input_labeled":"Input_input_labeled__cFtuC","input_small":"Input_input_small__Z4S+l"};